module.exports = __webpack_public_path__ + "media/images/icon_list/search-e5f615e265d360cec4fb1d510ffd523e.svg";